module.exports = __webpack_public_path__ + "media/flat/mastercard-7bb792a2.svg";